import $i18n from 'panda-i18n';
import * as React from 'react';
import { CnList, CnListItem } from '@/components/cn-list';
import { CnIcon } from '@/components/cn-icon';
function CascaderItemList(props) {
    const { options, mode, clsPrefix, loadData, val, loadingNode, onClick } = props;
    const loadingIcon = (React.createElement(CnIcon, { className: `${clsPrefix}-icon--loading`, type: "progressing", size: "small" }));
    return options.length === 0 ? (React.createElement("div", { className: `${clsPrefix}-not-found` }, $i18n.get({
        id: 'NoDataForTheTimeBeing_958511081',
        dm: '暂无数据',
        ns: 'CnCascaderSelect',
    }))) : (React.createElement(CnList, { className: `${clsPrefix}-list` }, options.map((item) => {
        let icon = null;
        const hasArrow = (loadData && !item.isLeaf) ||
            (!loadData && item.children && item.children.length > 0);
        const optionChecked = (loadData && item.value === val) || (!loadData && item.value === val);
        if (loadData && loadingNode === item.value) {
            icon = loadingIcon;
        }
        return (React.createElement(CnListItem, { className: optionChecked ? `${clsPrefix}-list-item-checked` : '', key: item.value, title: item.label, extra: icon, arrow: mode === 'cascade' && hasArrow && !icon ? 'right' : undefined, disabled: item.disabled, onClick: () => onClick(item) }));
    })));
}
export { CascaderItemList };
